import posthog from 'posthog-js';
import { getPostHogToken } from '@/envProvider';
import type { UserType } from '@/types/UserType';

export function usePostHog() {
    const token = getPostHogToken();
    if (token === undefined) {
        return { posthog };
    }
    posthog.init(token, {
        api_host: 'https://eu.i.posthog.com',
        defaults: '2026-01-30',
        enable_heatmaps: true,
    });

    return { posthog };
}

export function identifyUserInPostHog(userId: number, user: UserType) {
    posthog.identify(userId.toString(), {
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        tenant_id: user.tenant_id,
        language: user?.preferences?.language ?? 'unknown',
    });
}
